<template>
  <v-container fluid>
    <form>
      <v-text-field
        :value="dadosPessoais.nome"
        label="Nome"
        disabled
      ></v-text-field>
      <v-text-field
        :value="dadosPessoais.nomeSocial"
        label="Nome Social"
        disabled
      ></v-text-field>
      <v-text-field
        :value="dadosPessoais.cpf | cpf_formatado"
        label="CPF"
        disabled
      ></v-text-field>
      <v-text-field
        :value="dadosPessoais.rg"
        label="RG"
        disabled
      ></v-text-field>
      <v-text-field
        :value="dadosPessoais.curso"
        label="Curso"
        disabled
      ></v-text-field>
      <v-select :items="tiposRaca" v-model="dadosPessoais.raca" required>
        <template #label>
          Raça
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-select>
    </form>
    <v-toolbar elevation="0">
      <v-spacer></v-spacer>
      <v-btn color="primary" class="mr-4" @click="salvar"> Salvar </v-btn>
    </v-toolbar>
  </v-container>
</template>


<script>
import DadosPessoais from "@/models/dadosPessoais";
import * as DadosPessoaisService from "@/services/dados-pessoais.service";

export default {
  data() {
    return {
      dadosPessoais: new DadosPessoais(),
      tiposRaca: [
        { value: "AMARELA", text: "Amarela" },
        { value: "BRANCA", text: "Branca" },
        { value: "INDIGENA", text: "Indígena" },
        { value: "PARDA", text: "Parda" },
        { value: "PRETA", text: "Preta" },
        { value: "QUILOMBOLA", text: "Quilombola" },
        { value: "NAO_DECLARADA", text: "Não declarada" },
      ],
    };
  },
  mounted() {
    this.loadDados();
  },
  methods: {
    clear() {
      this.loadDados();
    },
    salvar() {
      this.$nprogress.start();
      DadosPessoaisService.create(this.dadosPessoais)
        .then(() => {
          this.$msg.success("Dados Pessoais salvos com sucesso!");
          this.$emit("salvou");
        })
        .finally(() => this.$nprogress.done());
    },
    loadDados() {
      this.$nprogress.start();
      DadosPessoaisService.getOne()
        .then(
          (res) =>
            (this.dadosPessoais = new DadosPessoais(
              res.data.id,
              res.data.nome,
              res.data.nomeSocial,
              res.data.cpf,
              res.data.rg,
              res.data.curso,
              res.data.raca
            ))
        )
        .finally(() => this.$nprogress.done());
    },
  },
};
</script>